export const isAssembleeGenerale = (type) =>
  type === 'assemblee_generale_ordinaire' || type === 'assemblee_generale_extraordinaire';

export const getReunionTypeLabel = (type, organisme) => {
  const labels = {
    assemblee_generale_ordinaire: 'Assemblée générale ordinaire',
    assemblee_generale_extraordinaire: 'Assemblée générale extraordinaire',
    conseil_syndical: organisme === 'SAR' ? 'Conseil syndical' : 'Conseil d\'administration',
    bureau: 'Bureau',
  };
  return labels[type] || type;
};

export const getReunionTypeShort = (type, organisme) => {
  if (type === 'assemblee_generale_ordinaire') return 'AGO';
  if (type === 'assemblee_generale_extraordinaire') return 'AGE';
  if (type === 'conseil_syndical') return organisme === 'SAR' ? 'CS' : 'CA';
  if (type === 'bureau') return 'Bureau';
  return type;
};

/** Nom de fichier du modèle de procès-verbal (aligné backend pvService). */
export const buildProcesVerbalFileName = (reunion) => {
  const date = new Date(reunion.date);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const dateStr = `${day}-${month}-${year}`;
  const typeShort = getReunionTypeShort(reunion.type, reunion.organisme);
  return `PV_${reunion.organisme}_${typeShort}_${dateStr}_modèle.doc`;
};

export const parseContentDispositionFilename = (disposition) => {
  if (!disposition) return null;
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;\n]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch {
      return utf8Match[1].trim();
    }
  }
  const quotedMatch = disposition.match(/filename="([^"]+)"/i);
  if (quotedMatch) return quotedMatch[1];
  const plainMatch = disposition.match(/filename=([^;\n]+)/i);
  if (plainMatch) return plainMatch[1].trim().replace(/^"|"$/g, '');
  return null;
};

export const formatReunionElectionLabel = (reunionElection, organisme) => {
  if (!reunionElection?.date) return '';
  const dateLabel = new Date(reunionElection.date).toLocaleDateString('fr-FR');
  return `${getReunionTypeShort(reunionElection.type, organisme)} ${dateLabel}`;
};

export const getConvocationButtonLabel = (type, organisme) => {
  if (isAssembleeGenerale(type)) return 'Convoquer les adhérents';
  if (type === 'bureau') return 'Convoquer le bureau';
  if (type === 'conseil_syndical') {
    return organisme === 'SAR'
      ? 'Convoquer les membres du conseil syndical'
      : 'Convoquer les membres du conseil';
  }
  return 'Convoquer';
};

export const getConvocationModalTitle = (type, organisme, typeOrganisme) => {
  if (isAssembleeGenerale(type)) return 'Convoquer les adhérents';
  if (type === 'bureau') return 'Convoquer le bureau';
  if (type === 'conseil_syndical') {
    return organisme === 'SAR' || typeOrganisme === 'syndicat'
      ? 'Convoquer le conseil syndical'
      : 'Convoquer le conseil d\'administration';
  }
  return 'Convoquer';
};
